// Author Liu Cui Cui
// Date 2023-07-19 15:09:39

class SithMesMstMaterialDrawingManagement {
    constructor({
                    id = null,
                    mmdMaterialCode = '',
                    mmdDrawingType = '',
                    mmdOperatorId = '',
                    mmdDrawingFileIds = '',
                    remark = '',
                    createdTime = '',
                    updatedTime = '',
                    mmdDrawingFiles = ''
                }
                    = {}) {
        this.id = id;
        this.mmdMaterialCode = mmdMaterialCode;
        this.mmdDrawingType = mmdDrawingType;
        this.mmdOperatorId = mmdOperatorId;
        this.mmdDrawingFileIds = mmdDrawingFileIds;
        this.remark = remark;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.mmdDrawingFiles = mmdDrawingFiles;
    }
}

function newEntity() {
    return new SithMesMstMaterialDrawingManagement();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdMaterialCode',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.mmdMaterialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingType',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.mmdDrawingType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '工艺图'},
                    {value: '2', text: '工程图'}
                ]
            }
        },
        {
            key: 'mmdOperator',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.mmdOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingFiles',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.mmdDrawingFiles',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.createdTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedTime',
            label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.grid.updatedTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    mmdMaterialCodeFilter: '',
    mmdDrawingTypeFilter: '',
    mmdOperatorIdFilter: '',
    mmdOperatorFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    updatedTimeRteFilter: '',
    updatedTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'mmdMaterialCodeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.mmdMaterialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.mmdDrawingType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工艺图'},
                {value: '2', text: '工程图'}
            ]
        }
    },
    {
        key: 'mmdOperatorFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.mmdOperator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.updatedTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.filter.updatedTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'mmdMaterialCode',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.mmdMaterialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingType',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.mmdDrawingType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工艺图'},
                {value: '2', text: '工程图'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.createdTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'updatedTime',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.updatedTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingFiles',
        label: 'label.sith.mst.sithMesMstMaterialDrawingManagement.entity.mmdDrawingFileIds',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'mmdDrawingFileIds'
        }
    }
]

export {
    SithMesMstMaterialDrawingManagement, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
